import { PERMISSION_COLUMNS_DISPLAY } from './permissioncolumns';

export const SAMPLE_ROLES_CSV = `sitename,id,name,description,accountid,${PERMISSION_COLUMNS_DISPLAY.join(',')}
demok12.scribonline.com,DCAdminRole,Singularity Administrator,Singularity Administration Group - full document archive admin and user/group admin,c86b4adf-0b00-4050-9d65-666ab59db8e9,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A,A
demok12.scribonline.com,ViewerRole,Document Viewer,Read-only access to documents,c86b4adf-0b00-4050-9d65-666ab59db8e9,D,A,D,D,D,A,D,A,D,D,D,A,D,D,D,D,D,D,D,D,D,D,D,A
`;

export const downloadSampleRolesCsv = (): void => {
  const blob = new Blob([SAMPLE_ROLES_CSV], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'sample-roles-import.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
